import { Box, Button, Checkbox, FormControlLabel, FormGroup, List, ListItem, ListItemIcon, ListItemText, Paper, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useHttpClientContext } from "../contexts/HttpClientContext";
import { useAuthContext } from "../contexts/AuthContext";

import { AxiosError } from "axios";
import { useEventContext } from "../contexts/EventContext";
import { useTranslation } from "react-i18next";
import { LoadingState } from "../components/shared/LoadingState";

//import "./NotificationTestPage.css";

const NotifyEventPage = () => {
    const httpClientContext = useHttpClientContext();
    const authContext = useAuthContext();
    const eventContext = useEventContext();
    const { t } = useTranslation();

    const [message, setMessage] = useState("");
    const [selectedEventId, setSelectedEventId] = useState(""); //259528_start_reg
    const [eventSearchText, setEventSearchText] = useState("");
    const [sending, setSending] = useState(false);
    const [sendToAll, setSendToAll] = useState(false);

    useEffect(() => {

        //TODO: check why we need this one ...
        if (httpClientContext.authenticatedClientReady) {
            authContext.user.match({
                loggedIn(user) {
                    if (!user.isInternalTester()) {
                        window.location.href = "/";
                        return;
                    }
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [httpClientContext.authenticatedClientReady]);

    const notify = () => {
        setSending(true);
        httpClientContext.authenticatedHttpClient.post("web-push/notify-event", {
            "eventId": sendToAll ? "259528_start_reg" : selectedEventId,
            "message": message
        }).then(() => {
            alert(t("notify_event.notification_sent"));
        })
            .catch((error: AxiosError) => {
                if (error.status === 404) {
                    alert("Aktiviteten saknar registrerade enheter.");

                } else {
                    alert("Ett fel har inträffat.")
                }
            })
            .finally(() => {
                setSending(false);
            });
    }

    return (
        <Box m={2}>

            {eventContext.events.match({
                loading: () => <LoadingState label={t("notify_event.loading")} />,
                success(events) {
                    return <>
                        <Box p={2}>
                            <Typography variant="h4">{t("notify_event.title")}</Typography>
                        </Box>

                        <Box p={2}>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox
                                    checked={sendToAll}
                                    onChange={(evt) => setSendToAll(evt.target.checked)}
                                />} label="Skicka till alla (259528_start_reg)" />
                            </FormGroup>
                        </Box>
                        {sendToAll === false &&
                            <Box p={2} sx={{ width: 'auto' }}>
                                <Stack>
                                    <TextField
                                        sx={{ mb: 2 }}
                                        value={eventSearchText}
                                        type="text"
                                        label="Sök aktivitet"
                                        onChange={evt => setEventSearchText(evt.target.value)}
                                    />
                                    <Paper elevation={3} sx={{ height: 250, overflow: 'auto' }}>
                                        <RadioGroup value={selectedEventId} onChange={(evt) => setSelectedEventId(evt.target.value)}>
                                            <List>
                                                {events.filter((evt) => evt.startDate && evt.startDate.startsWith("2026")).filter((evt) => eventSearchText.length ? evt.heading.toLocaleLowerCase().indexOf(eventSearchText.toLowerCase()) > -1 : true).map((item, index) => (
                                                    <ListItem key={index} onClick={() => setSelectedEventId(item.eventId)}>
                                                        <ListItemIcon>
                                                            <Radio
                                                                edge="start"
                                                                value={item.eventId}
                                                                checked={selectedEventId === item.eventId}
                                                                tabIndex={-1}
                                                                disableRipple
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText primary={`${item.startDate} ${item.startTime}-${item.endTime} - ${item.heading}`} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </RadioGroup>
                                    </Paper>
                                </Stack>
                            </Box>
                        }
                        <Box p={2} sx={{ width: 'auto' }}>
                            <Stack>
                                <TextField
                                    sx={{ mb: 2 }}
                                    value={message}
                                    type="text"
                                    label={t("notify_event.message")}
                                    onChange={evt => setMessage(evt.target.value)}
                                />
                                <Button variant="contained" onClick={notify} disabled={!message.length || !selectedEventId.length || sending}>{t("notify_event.notify")}</Button>
                            </Stack>
                        </Box>
                    </>
                }
            })}
        </Box>
    );
}

export default NotifyEventPage;
